import React from 'react';
import { string, shape } from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  headingRoot: {
    maxWidth: 800,
    margin: '0 auto',
    fontSize: '2.25rem',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.h2.fontSize,
    },
    '& span': {
      color: theme.palette.secondary.main,

      '&.nowrap': {
        whiteSpace: 'nowrap',
      },
    },
  },
  subheadingRoot: {
    maxWidth: 800,
    margin: '0 auto',
    lineHeight: '1.25',
    [theme.breakpoints.up('md')]: {
      lineHeight: '1.5',
    },
    '& a': {
      color: theme.palette.primary.main,
      '&:visited': {
        color: theme.palette.primary.main,
      },
    },
  },
  helperRoot: {
    fontSize: `0.8125rem`,
    paddingTop: theme.spacing(1),
    '& span': {
      color: theme.palette.secondary.main,
    },
  },
}));

const Heading = ({ heading, subheading, icon, helper }) => {
  const classes = useStyles();
  const image = icon?.svg && (
    <Box display="flex" justifyContent="center" mb={2}>
      <img src={icon.svg} alt={icon.alt} />
    </Box>
  );

  const helperText = helper && (
    <Typography
      classes={{ root: classes.helperRoot }}
      variant="body2"
      align="center"
      color="textSecondary"
      dangerouslySetInnerHTML={{
        __html: helper,
      }}
    />
  );

  const assembly = Boolean(process.env.NEXT_PUBLIC_ASSEMBLY === 'true');

  return (
    <Box mb={4}>
      {!assembly && image}
      <Typography
        classes={{ root: classes.headingRoot }}
        component="h1"
        variant="h2"
        align="center"
        dangerouslySetInnerHTML={{
          __html: heading,
        }}
      />
      <Typography
        classes={{ root: classes.subheadingRoot }}
        variant="body1"
        color="textSecondary"
        align="center"
        dangerouslySetInnerHTML={{
          __html: subheading,
        }}
      />
      {helperText}
    </Box>
  );
};

Heading.propTypes = {
  heading: string.isRequired,
  subheading: string.isRequired,
  helper: string,
  icon: shape({
    svg: string,
    alt: string,
  }),
};

Heading.defaultProps = {
  icon: {
    svg: '',
    alt: '',
  },
  helper: '',
};

export default Heading;
